import { render, staticRenderFns } from "./SectionTitleTable.vue?vue&type=template&id=640a21a6&"
import script from "./SectionTitleTable.vue?vue&type=script&lang=js&"
export * from "./SectionTitleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports